
import wareView from "../components/ware-view"
import breadcrumb from "../library/breadcrumb.vue"
import getCartNumMixin from "@/mixins/getCartNum"
import { genfilterAndSortParams, getWareListAndResultTips, handlePropertyList } from "@/utils/category"
import commonConfig from "@/utils/common"
import { wareSearch, searchTemplateData } from "@/api/category.js"
import { Logger } from "@/plugins/logger"
import { getRequestHeaders, getDshopUrlPath, formatProductParamsBy } from "@/utils/utils"
import { translate } from "@/plugins/i18n"
import { trackSearchSuccess } from "@/utils/track"
import { getPaths } from "@/plugins/env"

export default {
  name: "Search",
  components: {
    wareView,
    breadcrumb
  },
  mixins: [getCartNumMixin],
  props: {
    configs: {
      type: Object,
      default: () => {}
    }
  },
  async asyncData({ req, error, query, store, redirect, route, $cookies }) {
    let searchResultRes = {}
    let haveCategoryRes = {}
    try {
      const commonParams = store.state.commonParams
      const commonReqParams = {
        businessCode: commonParams.businessCode || 1,
        categoryType: 1,
        erpStoreId: commonParams.storeId,
        venderId: commonParams.venderId
      }
      const filterAndSortParams = genfilterAndSortParams(query)
      const searchParam = {
        ...commonReqParams,
        keyword: query.keyword,
        pageNum: query.page || 1,
        pageSize: 20,
        ...filterAndSortParams,
        ...formatProductParamsBy({}, $cookies)
      }
      try {
        const [res, templateRes] = await Promise.all([
          wareSearch({ param: searchParam }, { headers: getRequestHeaders({ req, store }) }),
          searchTemplateData({ param: searchParam }, { headers: getRequestHeaders({ req, store }) })
        ])
        searchResultRes = res.data
        haveCategoryRes = templateRes.data
      } catch (error) {
        console.log("Error occurred during API call:", error)
      }
      if (haveCategoryRes.redirectUrl && haveCategoryRes.redirectUrl != "null") {
        const { MAIN_PATH } = getPaths()
        redirect(`${MAIN_PATH}/d/${getDshopUrlPath(haveCategoryRes.redirectUrl)}.html`)
      }
      const wareListAndTips = getWareListAndResultTips(searchResultRes, query.keyword)
      const wareList = wareListAndTips.wareList

      const searchResultTip = wareListAndTips.searchResultTip
      const lang = store.state.lang
      return {
        pageTitle: translate("common.searchResult"),
        wareList,
        keyword: haveCategoryRes.keyword,
        filterProperties: handlePropertyList(haveCategoryRes.filterProperty),
        noResultData: searchResultRes.noResultData,
        pageInfo: searchResultRes.pageInfo || {},
        lang: lang == "en_US" ? "en" : "zh-hant",
        searchResultTip
      }
    } catch (err) {
      Logger.error("search result page 初始化报错", err)
      error({
        statusCode: 500,
        message: "Internal Server Error"
      })
    }
  },
  data() {
    return {
      searchResultTip: "",
      keyword: "",
      loading: false,
      wareList: [],
      noResultData: {},
      filterProperties: [],
      showHeader: false,
      breadcrumbData: [
        {
          name: this.$t("common.home"),
          path: "/"
        },
        { name: this.$t("common.searchResult") }
      ],
      spellCheckTip: ""
    }
  },
  head() {
    return {
      title: this.pageTitle
    }
  },
  computed: {
    hasWare() {
      return this.wareList.length > 0
    }
  },
  watchQuery: ["keyword", "page"],
  mounted() {
    this.trackSearchSuccess()
  },
  methods: {
    trackSearchSuccess() {
      trackSearchSuccess(this.keyword, this.pageInfo?.total)
    }
  }
}
